import { render } from "./ProfilePasswordEdit.vue?vue&type=template&id=2f7c9706&lang=pug"
import script from "./ProfilePasswordEdit.vue?vue&type=script&lang=js"
export * from "./ProfilePasswordEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__